import _ from 'lodash';

class TNTControlController {
  /*@ngInject*/
  constructor(Auth, $state, User, $translate, $location, Modal, DataCounter, $q, HoldService, HoldLocationService, $rootScope, UsersService, CommonLayoutService) {

    this.$state = $state

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.$location = $location;
    this.HoldLocationService = HoldLocationService;
    this.HoldService = HoldService;
    this.Modal = Modal;
    this.DataCounter = DataCounter
    this.holdServiceData = []
    this.itemHoldServiceData = []
    this.$rootScope = $rootScope;
    this.UsersService = UsersService;
    this.CommonLayoutService = CommonLayoutService;
    this.currentBranch = User.getUser().branchId;
    this.tabConfig = {
      'tnt_control_branch_setup': {
        title: 'branch_setup.menu.title',
        state: 'setup',
      },
      'tnt_control_shiptype': {
        title: 'shiptype.menu.title',
        state: 'shiptype'
      },
      'tnt_control_denomination': {
        title: 'denomination.menu.title',
        state: 'denomination'
      },
      'tnt_control_currency': {
        title: 'currency.menu.title',
        state: 'currency'
      },
      'tnt_control_message': {
        title: 'message.menu.title',
        state: 'message'
      },
      'tnt_control_mobile_app': {
        title: 'mobileApp.menu.title',
        state: 'mobile_app'
      },
      'tnt_control_user_permission_report': {
        title: 'userPermissionReport.menu.title',
        state: 'user_permission_report'
      },
      'tnt_control_atm_load_profile': {
        title: 'atmLoadProfile.menu.title',
        state: 'atm_load_profile'
      },
      'tnt_control_cost_center': {
        title: 'costCenter.menu.title',
        state: 'cost_center'
      },
      'tnt_control_environment_config': {
        title: 'environment_config.menu.title',
        state: 'environment_config'
      },
      'tnt_control_location_zone': {
        title: 'locationZone.menu.title',
        state: 'location_zone',
      },
      'tnt_control_notification_management': {
        title: 'notificationManagement.menu.title',
        state: 'notification_management',
      },
      'tnt_control_service_assignment_rules': {
        title: 'serviceAssignmentRules.menu.title',
        state: 'service_assignment_rules'
      }
    };

    this.acl = User.getACL('tntControl');
    this.tabs = [];
  }

  getStateDiff(array) {
    let diff = []
    let index = 0
    for (let i = 0; i < array.length; i++) {
      let key = array[i];
      if (!(key in this.acl)) {
        diff[index++] = array[i]
      }
    }
    return diff
  }

  $onInit() {
    const firstName = this.User.getUser().firstName;
    const lastName = this.User.getUser().lastName;

    this.$q.all([
      this.UsersService.validateUserPermissions(firstName, lastName)
    ])
      .then(([permission]) => {
        if (!permission.hasEnvironmentConfigPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
          delete this.tabConfig['tnt_control_environment_config'];

          if (this.validateUserPermissionsAndState('/environment-config')) {
            return this.$state.go('home');
          }
        }

        let toDeregister = this.getStateDiff(Object.keys(this.tabConfig))
        for (let i = 0; i < toDeregister.length; i++) {
          if (this.$state.get(toDeregister[i])) {
            this.$state.router.stateRegistry.deregister(toDeregister[i])
          }
        }

        _.forEach(Object.keys(this.tabConfig), (key, i) => {
          if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
            let tabConfig = this.tabConfig[key];
            if (tabConfig) {
              let obj = Object.assign(tabConfig, { key })
              this.tabs.push(obj);
            }
          }
        })

        if (this.$state.current.name == 'tntControl' && this.tabs.length) {
          this.$state.go(this.tabs[0].state)
        }

        this.$rootScope.$broadcast('routeChange', null);
      })
      .catch(err => {
        console.log(err);
      })
  }

  hasAcl(key) {
    if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
      return true;
    } else {
      return false;
    }
  }

  validateUserPermissionsAndState(wordToCheck) {
    let currentStateUrl = this.$state.href(this.$state.current);
    return currentStateUrl.toLowerCase().includes(wordToCheck)
  }
}

export default TNTControlController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/tnt_control.controller.js